"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "make", "valueChanged"],
  _excluded2 = ["make", "className"];
var _FleetMakeSelect_HomepageQuery, _InputLoading;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { InputLoading } from '@autoguru/components';
import { VehicleMakeSelect } from '@autoguru/components/components/VehicleMakeSelect/VehicleMakeSelect';
import { AsyncBoundary } from '@autoguru/suspense';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const FleetMakeSelectInput = _ref => {
  let {
      className = '',
      make,
      valueChanged
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  const {
    vehicleMakes
  } = useLazyLoadQuery(_FleetMakeSelect_HomepageQuery !== void 0 ? _FleetMakeSelect_HomepageQuery : _FleetMakeSelect_HomepageQuery = require("../../../../../packages/relay/__generated__/FleetMakeSelect_HomepageQuery.graphql"), null);
  return /*#__PURE__*/_jsx(VehicleMakeSelect, _objectSpread(_objectSpread({
    className: className
  }, inputProps), {}, {
    makes: vehicleMakes,
    make: make,
    onChange: valueChanged
  }));
};
export const FleetMakeSelect = _ref2 => {
  let {
      make,
      className
    } = _ref2,
    inputProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: _InputLoading || (_InputLoading = /*#__PURE__*/_jsx(InputLoading, {})),
    children: /*#__PURE__*/_jsx(FleetMakeSelectInput, _objectSpread({
      make: make,
      className: className
    }, inputProps))
  });
};